import classnames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { RouteComponentProps } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { RootStoreContext } from "../app/stores/rootStore";
import TreeComponent from "../components/widgets/TreeComponent";
import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock";
import SaveOfflineBoardButton from "../components/buttons/SaveOfflineBoardButton";
import LanguageDropdown from "../components/dropdowns/LanguageDropdown";
import { translationHookOptions } from "../app/localization/localization";
import { useTranslation } from "react-i18next";

const BoardPage: React.FC<RouteComponentProps> = () => {
  const rootStore = useContext(RootStoreContext);
  const { loadMainBoard, mainBoardTree } = rootStore.boardStore;
  const { isNativeApp, selectedLanguageId, theme } = rootStore.commonStore;
  const { currentTenant } = rootStore.tenantStore;
  const { setSourceId } = rootStore.meetingStore;
  const { attendingMeeting } = rootStore.playerStore;
  const [t] = useTranslation(["features"], translationHookOptions);
  const {isMobileMediaQuery} = rootStore.responsiveStore;

  useEffect(() => {
    if (attendingMeeting) setSourceId(attendingMeeting.id);
    else setSourceId(null);

    loadMainBoard(selectedLanguageId).then().catch();
    const scrollableElement = document.querySelector(".odgPage");
    if (scrollableElement) disableBodyScroll(scrollableElement);

    return () => {
      const scrollableElement = document.querySelector(".odgPage");
      if (scrollableElement) enableBodyScroll(scrollableElement);
    };
  }, [loadMainBoard, selectedLanguageId, attendingMeeting, setSourceId]);

  return (
    <div className="odgPage">
      <Row>
        <div
          className={classnames(isMobileMediaQuery ? "odgTitoloMobile" :
            "odgTitolo",
            `${theme!.titleBarBgOdg} ${theme!.titleBarTextOdg}`
          )}
        >
          {t("board_page_title_bar")}
          {isNativeApp && mainBoardTree && (
            <SaveOfflineBoardButton
              board={mainBoardTree}
              tenant={currentTenant!}
            />
          )}
        </div>
      </Row>
      <Row>
        <div className={classnames(isMobileMediaQuery ? "odgSottoTitoloMobile" :
            "odgSottoTitolo")}>
          <div className="float-right mr-3">
            {mainBoardTree && (
              <>
                {/* da fare canDownload */}
                {/* {!isNativeApp && (
                  <DownloadZipButton
                    url={`/content/${sourceType}/${mainBoardTree.boardId}/zip?languageId=${mainBoardTree.languageId}`}
                    color={theme!.buttonColor}
                  />
                )} */}
                <LanguageDropdown
                  languages={mainBoardTree.availableLanguages!}
                  selectedLanguage={mainBoardTree.languageId!}
                  className="py-0"
                  onLanguageSelect={(langId?: number) => {
                    loadMainBoard(langId);
                  }}
                  flagFontSize={25}
                />
              </>
            )}
          </div>
        </div>
      </Row>
      <Row>
        <Col xs={12} className="odgContainer">
          {mainBoardTree && (
            <TreeComponent
              tenant={currentTenant!}
              nodes={mainBoardTree.tree}
              type="boards"
              sourceId={mainBoardTree.boardId}
            />
          )}
        </Col>
      </Row>
    </div>
  );
};

export default observer(BoardPage);
